

var user=function() {
  return window.appRoot.loggedIn || {allPayments: []};
}

var all=function() {
  return user().allPayments.slice().sort((a,b)=>{
    if (a.endDate<b.endDate) return 1;
    if (a.endDate>b.endDate) return -1;
    return 0;
  });
}

var active=function() {
  return all().filter((a)=>a.isActive);
}

var past=function() {
  return all().filter((a)=>!a.isActive);
}

var forVideo=function(video, parent) {
  return all().find((a)=>a.video==video || (parent && a.video==parent));
}

var forGroup=function(group) {
  return all().find((a)=>a.videogroup && a.videogroup.id==group);
}

var forType=function(type) {
  var types=[type];
  var vt=window.appData.videoTypes.find(a=>a.id==type);
  while(vt && vt.parent) {
    types.push(vt.parent);
    vt=window.appData.videoTypes.find(a=>a.id==vt.parent);
  }
  return active().find((a)=>(
    a.videogroup && (
      types.indexOf(a.videogroup.type)!=-1 ||
      types.indexOf(a.videogroup.type2)!=-1 ||
      types.indexOf(a.videogroup.type3)!=-1 ||
      types.indexOf(a.videogroup.type4)!=-1 ||
      types.indexOf(a.videogroup.type5)!=-1 ||
      types.indexOf(a.videogroup.type6)!=-1)
  ));
}

export default {
  methods: {
    paymentActive: active,
    paymentPast: past,
    paymentAll: all,
    paymentForVideo: forVideo,
    paymentForGroup: forGroup,
    paymentForType: forType,
  }
}
